import {INTERNO_STR} from "../constants/Constants";

export function isInternUser() {
    return localStorage.getItem('institution') === INTERNO_STR;
}

export function isValidPassword(stringPass){
    let isValid = false;
    let regexPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&/()=?@*.,+\\-])[A-Za-z0-9!"#$%&/()=?@*.,+\\-]{12,15}$/;
    let regexNonConsecutive = /(.)\1+/;

    if (stringPass.match(regexPattern)){
        if(!stringPass.match(regexNonConsecutive)){
            let strPassLower = stringPass.toLowerCase();
            let userNameLower = localStorage.getItem('username').toLowerCase();
            isValid = !strPassLower.includes(userNameLower);
        }
    }
    return isValid;
}

export function isValidDomain(stringDomain){
    let isValid = false;
    let regexPattern = /^(https?):\/\/[\w\-_]+(\.?[\w\-_]+)+([\w\-.?:/]*[\w\-.?:/])?\/$/;
    let ipPattern = /^((?:2[0-5]{2}|1\d{2}|[1-9]\d|[1-9])\.(?:(?:2[0-5]{2}|1\d{2}|[1-9]\d|\d)\.){2}(?:2[0-5]{2}|1\d{2}|[1-9]\d|\d))+(:(\d|[1-9]\d|[1-9]\d{2,3}|[1-5]\d{4}|6[0-4]\d{3}|654\d{2}|655[0-2]\d|6553[0-5]))?$/;

    if (stringDomain.match(regexPattern)){
        let arrayDomain = stringDomain.split("/");
        //tomamos por ejemplo: 150.50.102.73:6020
        let urlAux = arrayDomain[2].split(":");
        let url = urlAux[0];
        let port = arrayDomain.length > 1 ? urlAux[1] : "";
        let allNumbers = allNumbersInArray(url.split("."));

        if(url.split(".").length === 4){
            if(allNumbers){
                isValid = arrayDomain[2].match(ipPattern);
            }else {
                isValid = isNaN(port) ? true : (port >= 0 && port <= 65535);
            }
        }else{
            isValid = true;
        }
    }
    return isValid;
}

function allNumbersInArray(array){
    let allNumbers = true;
    for(let elem in array){
        if (isNaN(array[elem])){
            allNumbers = false;
            return;
        }
    }
    return allNumbers;
}


